// Hook (use-require-auth.js)
import { useEffect } from "react";
import { getNextOnboardingPath } from "utils/get-next-onboarding-path";
import { useAuth } from "./use-auth";
import useRouter from "./use-router";

const useRequireAuth = () => {
  const auth = useAuth();
  const { push, location, query } = useRouter();

  useEffect(() => {
    const next = Array.isArray(query.next) ? query.next[0] : query.next;
    const nextPath = getNextOnboardingPath(
      location.pathname,
      auth.user,
      auth.flows,
      auth.flow,
      next
    );
    if (nextPath) {
      // eslint-disable-next-line no-console
      console.log(`redirect to ${nextPath}`, {
        path: location.pathname,
        user: auth.user,
      });

      push(nextPath);
    }
  }, [auth.user, auth.flows, auth.flow, location.pathname, push, query.next]);

  return auth;
};
export default useRequireAuth;
